import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import _sfc_main$1 from "./control_string.vue.js";
import { hasIconSizeBinding, iconNameToTemplate, iconNames, templateToIconName } from "../../lib/icons.js";
import { Fragment, computed, createBlock, createElementBlock, createElementVNode, createTextVNode, createVNode, mergeProps, openBlock, ref, renderList, renderSlot, resolveDynamicComponent, toDisplayString, unref, watch, withCtx, withModifiers } from "vue";
import { DtButton, DtListItem, DtRecipeComboboxWithPopover } from "@dialpad/dialtone-vue";
import { DtIconChevronsUpDown, DtIconClose } from "@dialpad/dialtone-icons/vue";
//#region src/components/controls/control_icon_slot.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlIconSlot" }, {
	props: {
		value: {
			type: void 0,
			default: () => null
		},
		disabled: {
			type: Boolean,
			default: false
		},
		bindings: {
			type: Array,
			default: () => []
		},
		defaultValue: {
			type: void 0,
			default: () => null
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const NONE_OPTION = "(none)";
		const props = __props;
		const emit = __emit;
		const searchText = ref(templateToIconName(props.value) ?? "");
		watch(() => props.value, (newVal) => {
			searchText.value = templateToIconName(newVal) ?? "";
		});
		const isModified = computed(() => props.value !== props.defaultValue);
		const allIcons = computed(() => [NONE_OPTION, ...iconNames]);
		const filteredIcons = computed(() => {
			const query = searchText.value.toLowerCase();
			if (!query) return allIcons.value;
			return allIcons.value.filter((name) => name.toLowerCase().includes(query));
		});
		const combobox = ref();
		const open = ref(false);
		function onOpen(e) {
			open.value = e;
		}
		function onFocusOut(e) {
			if (e.relatedTarget?.closest("[data-tippy-root]")) return;
			if (combobox.value?.$el?.contains(e.relatedTarget)) return;
			if (open.value) combobox.value?.closeComboboxList();
		}
		function onSelectInternal(i) {
			combobox.value.onSelect(i);
			combobox.value.closeComboboxList();
		}
		function onSelect(iconName) {
			if (iconName === NONE_OPTION) {
				searchText.value = "";
				emit(VALUE_UPDATE_EVENT, null);
				return;
			}
			searchText.value = iconName;
			emit(VALUE_UPDATE_EVENT, iconNameToTemplate(iconName, hasIconSizeBinding(props.bindings)));
		}
		function onReset() {
			searchText.value = templateToIconName(props.defaultValue) ?? "";
			emit(VALUE_UPDATE_EVENT, props.defaultValue);
		}
		function onInputInternal(value, onInput) {
			searchText.value = value;
			if (!value) emit(VALUE_UPDATE_EVENT, null);
			onInput(value);
		}
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(DtRecipeComboboxWithPopover), {
				ref_key: "combobox",
				ref: combobox,
				label: "Icon",
				"max-height": "320px",
				"list-class": "d-w-250 d-hmx-350",
				size: 100,
				"append-to": "body",
				onSelect: _cache[0] || (_cache[0] = (e) => onSelect(filteredIcons.value[e])),
				onOpened: onOpen,
				onFocusout: onFocusOut
			}, {
				input: withCtx(({ inputProps, onInput }) => [createVNode(_sfc_main$1, mergeProps(inputProps, {
					value: searchText.value,
					disabled: __props.disabled,
					onInput: (e) => onInputInternal(e, onInput)
				}), {
					default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
					icon: withCtx(({ iconSize }) => [isModified.value ? (openBlock(), createBlock(unref(DtButton), {
						key: 0,
						kind: "muted",
						importance: "clear",
						size: 100,
						class: "d-p-25",
						onClick: withModifiers(onReset, ["stop"])
					}, {
						icon: withCtx(() => [createVNode(unref(DtIconClose), { size: "100" })]),
						_: 1
					})) : (openBlock(), createBlock(resolveDynamicComponent(unref(DtIconChevronsUpDown)), {
						key: 1,
						size: iconSize,
						class: "d-fc-muted"
					}, null, 8, ["size"]))]),
					_: 3
				}, 16, [
					"value",
					"disabled",
					"onInput"
				])]),
				list: withCtx(({ listProps }) => [createElementVNode("ul", mergeProps({ class: "d-p-50" }, listProps), [(openBlock(true), createElementBlock(Fragment, null, renderList(filteredIcons.value, (item, i) => {
					return openBlock(), createBlock(unref(DtListItem), {
						key: item,
						"navigation-type": "arrow-keys",
						role: "option",
						onClick: ($event) => onSelectInternal(i)
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(item), 1)]),
						_: 2
					}, 1032, ["onClick"]);
				}), 128))], 16)]),
				_: 3
			}, 512);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_icon_slot.vue.js.map